module.exports = __webpack_public_path__ + "img/redand.9f0015da.png";